import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, Input, H3, Text } from '@bigcommerce/big-design';

import { markPOFulfilled } from '../../redux/actions/purchaseOrders';

const MarkFulfilledModal = ({ payload, showMarkFulfilledModal, setShowMarkFulfilledModal, purchaseOrder, markFulfilled }) => {
  const update = () => {
    markFulfilled(payload, purchaseOrder.id);
    setShowMarkFulfilledModal(false);
  }

  return(
    <>
      { purchaseOrder &&
        <Modal
          actions={[
            {
              text: 'Cancel',
              variant: 'subtle',
              onClick: () => setShowMarkFulfilledModal(false),
            },
            { text: 'Mark Fulfilled', onClick: () => update() },
          ]}
          closeOnClickOutside={true}
          closeOnEscKey={true}
          header="Mark Fulfilled"
          isOpen={showMarkFulfilledModal}
          onClose={() => setShowMarkFulfilledModal(false)}
        >
          <H3>{purchaseOrder.invoice_number || purchaseOrder.id}</H3>
          <Text>Override the Supplier Purchase Order app's default behavior and mark this order fulfilled. You may need to do this in cases where received inventory are intentionally different from what is sent to Suppliers, and you know that the correct amount has been received.</Text>
          <Text>Confirm that all products have been received for this order?</Text>
        </Modal>
      }
    </>
  )
}

const mapStateToProps = state => ({ 
});

const mapDispatchToProps = (dispatch) => ({
  markFulfilled: (payload, purchaseOrderId) => dispatch(markPOFulfilled(payload, purchaseOrderId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MarkFulfilledModal);
